import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const shimmer = keyframes`
  from {
    background-position: -1000px 0;
  }

  to {
    background-position: 1000px 0;
  }
`;

const SkeletonLoaderDiv = styled('div')<{ shimmerColor?: string; shimmerDarkColor?: string }>`
  background-color: ${(props) => props.shimmerColor};
  background-image: linear-gradient(
    to right,
    ${(props) => props.shimmerColor} 0%,
    ${(props) => props.shimmerDarkColor} 20%,
    ${(props) => props.shimmerColor} 50%,
    ${(props) => props.shimmerColor} 100%
  );
  background-repeat: no-repeat;
  background-size: 1000px 100%;
  animation: ${shimmer} 1s linear infinite forwards;
  border-radius: ${tokens.radius.m};
`;

export interface SkeletonLoaderProps {
  className?: string;
  shimmerColor?: string;
  shimmerDarkColor?: string;
}

export function SkeletonLoader({
  className,
  shimmerColor = tokens.color.neutral_300,
  shimmerDarkColor = tokens.color.neutral_400,
}: SkeletonLoaderProps): JSX.Element {
  return (
    <SkeletonLoaderDiv
      className={className}
      shimmerColor={shimmerColor}
      shimmerDarkColor={shimmerDarkColor}
    />
  );
}
